import React from 'react'
import './WorkToday.scss'

const WorkToday: React.FC = () => {
  return (
    <div className="work-today">
      <div className="work-today__header">
        <h1 className="work-today__title">Arbeit Heute</h1>
        <p className="work-today__subtitle">Deine beruflichen Aufgaben und Projekte</p>
      </div>

      <div className="work-today__content">
        <div className="work-today__section">
          <h2 className="work-today__section-title">🚀 Prioritäten</h2>
          <div className="work-today__priority-list">
            <div className="work-today__priority work-today__priority--high">
              <span className="work-today__priority-label">HOCH</span>
              <span>Präsentation für Kundenmeting fertigstellen</span>
            </div>
            <div className="work-today__priority work-today__priority--medium">
              <span className="work-today__priority-label">MITTEL</span>
              <span>Code Review für Feature-Branch</span>
            </div>
            <div className="work-today__priority work-today__priority--low">
              <span className="work-today__priority-label">NIEDRIG</span>
              <span>Dokumentation aktualisieren</span>
            </div>
          </div>
        </div>

        <div className="work-today__section">
          <h2 className="work-today__section-title">📊 Projekte</h2>
          <div className="work-today__projects">
            <div className="work-today__project">
              <div className="work-today__project-header">
                <span className="work-today__project-name">HappyTask v2.0</span>
                <span className="work-today__project-progress">75%</span>
              </div>
              <div className="work-today__progress-bar">
                <div className="work-today__progress-fill" style={{ width: '75%' }}></div>
              </div>
            </div>
            <div className="work-today__project">
              <div className="work-today__project-header">
                <span className="work-today__project-name">API Migration</span>
                <span className="work-today__project-progress">40%</span>
              </div>
              <div className="work-today__progress-bar">
                <div className="work-today__progress-fill" style={{ width: '40%' }}></div>
              </div>
            </div>
          </div>
        </div>

        <div className="work-today__section">
          <h2 className="work-today__section-title">📅 Meetings</h2>
          <div className="work-today__meetings">
            <div className="work-today__meeting">
              <span className="work-today__meeting-time">09:00</span>
              <div className="work-today__meeting-info">
                <span className="work-today__meeting-title">Daily Standup</span>
                <span className="work-today__meeting-location">Teams</span>
              </div>
            </div>
            <div className="work-today__meeting">
              <span className="work-today__meeting-time">14:30</span>
              <div className="work-today__meeting-info">
                <span className="work-today__meeting-title">Sprint Review</span>
                <span className="work-today__meeting-location">Konferenzraum A</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WorkToday